import { defineStore } from 'pinia';
import { API_URL, authFetch } from '../api';

export const useExpenseStore = defineStore('expenses', {
  state: () => ({
    expenses: [],
    categoryData: null,
    loading: false,
    error: null,
  }),
  actions: {
    async fetchExpenses() {
      this.loading = true;
      try {
        const response = await authFetch(`${API_URL}/expenses`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        this.expenses = await response.json();
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async addExpense(expense) {
      try {
        const transformedExpense = {
          ...expense,
          date: expense.date ? new Date(expense.date).toISOString().split('T')[0] : null,
          end_date: expense.end_date ? new Date(expense.end_date).toISOString().split('T')[0] : null
        };
        
        const response = await authFetch(`${API_URL}/expenses`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(transformedExpense),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const newExpense = await response.json();
        this.expenses.push(newExpense);
        return newExpense;
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async deleteExpense(expenseId) {
      try {
        const response = await authFetch(`${API_URL}/expenses/${expenseId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        this.expenses = this.expenses.filter(expense => expense.id !== expenseId);
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async fetchCategoryData(startDate, endDate) {
      try {
        const params = new URLSearchParams();
        if (startDate) params.append('start_date', startDate);
        if (endDate) params.append('end_date', endDate);
        const response = await authFetch(`${API_URL}/charts/expenses-by-category/?${params}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        this.categoryData = await response.json();
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async updateExpense(expenseId, expense) {
      try {
        const transformedExpense = {
          ...expense,
          date: expense.date ? new Date(expense.date).toISOString().split('T')[0] : null,
          end_date: expense.end_date ? new Date(expense.end_date).toISOString().split('T')[0] : null
        };

        const response = await authFetch(`${API_URL}/expenses/${expenseId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(transformedExpense),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const updatedExpense = await response.json();
        const index = this.expenses.findIndex(e => e.id === expenseId);
        if (index !== -1) {
          this.expenses[index] = updatedExpense;
        }
        return updatedExpense;
      } catch (error) {
        this.error = error;
        throw error;
      }
    }
  }
});